import { Params } from '@angular/router';
import { IgMedia } from '@core/models/ApiFields/ig-entities';
import { SingleDimChartFormatter } from '@features/social-analysis/components/chart/utils/chart-opts-format';
import { IData } from '@core/models/IApi';
import { IG_ENDPOINT } from '@features/social-analysis/social-listening/config/api-params';
import { ChartState } from '@features/social-analysis/social-shared/store/chart.store';
import { PageFiltersState } from '@features/social-analysis/social-shared/store/page-filters.store';
import { DATA_STATUS } from '@features/social-analysis/social-shared/store/state.store';
import { ChartHttpBuilder } from './chart.http';

export class PostChartHttpBuilder extends ChartHttpBuilder {
    protected formatter: SingleDimChartFormatter = new SingleDimChartFormatter();

    reqData(state: ChartState, pageFilters: PageFiltersState, postId: string): void {
        const url = this.buildUrl(IG_ENDPOINT);
        const params = this.buildParams(state, pageFilters, postId);

        state.isLoading.set(true);
        this.setLoadingOpts(state);
        this.makeGetReq(url, params, state);
    }

    protected buildParams(
        { dimensions, metrics }: ChartState,
        pageFilters: PageFiltersState,
        postId: string
    ): Params {
        return {
            ...this.getDates(pageFilters.selectedDates()),
            ...this.getFields(dimensions(), metrics()),
            ...this.getSort(dimensions()),
            ...this.getMode(),
            ...this.getMediaTypeFilter(),
            ...this.getFilters(pageFilters.appliedFilters()),
            ...this.getPostId(postId),
        };
    }

    protected getMediaTypeFilter() {
        return { [IgMedia.getPrefixed('mediaType')]: 'neq:tag' };
    }

    protected setLoadingOpts(state: ChartState) {
        const opts = this.formatter.getLoadingChart();
        state.computedData.set(opts);
    }

    override handleSuccess(state: ChartState, data: IData[]): void {
        state.data.set(data);
        state.dataStatus.set(DATA_STATUS.OK);
        this.setChartOpts(state, data);
    }

    protected setChartOpts(state: ChartState, data: IData[]) {
        state.isLoading.set(false); // otherwise it will always set loading UI ( finalize operator runs after handleSuccess )
        const opts = this.formatter.getChartOpts(state, data);
        state.computedData.set(opts);
    }
}
